import { OPERATION_TYPE } from "interfaces";
import { observer } from "mobx-react-lite";
import { useEffect, useState, useCallback, useRef } from "react";

import { useStores } from "stores";
import { CustomButton } from "ui";
import { OfferQuoteModal } from "./OfferQuoteModal";
import { canSendSms, getLastSentTime } from "utils";

export const OfferQuoteButton = observer(() => {
  const { actionModals } = useStores();
  const [timeLeft, setTimeLeft] = useState(0);
  const [canSendSmsCode, setCanSendSmsCode] = useState(true);
  const intervalRef = useRef<NodeJS.Timeout>();

  const checkSmsAvailability = useCallback(() => {
    const canSend = canSendSms(OPERATION_TYPE.QUOTE_CREATE);
    setCanSendSmsCode(canSend);

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = undefined;
    }

    if (!canSend) {
      const remainingTime = getLastSentTime(OPERATION_TYPE.QUOTE_CREATE);
      if (remainingTime > 0) {
        setTimeLeft(remainingTime);
        intervalRef.current = setInterval(() => {
          setTimeLeft((prev) => {
            const next = prev - 1;
            if (next <= 0) {
              if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = undefined;
              }
              setCanSendSmsCode(true);
              return 0;
            }
            return next;
          });
        }, 1000);
      }
    }
  }, []);

  useEffect(() => {
    checkSmsAvailability();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [checkSmsAvailability]);

  const offerQuoteHandler = () => {
    actionModals.open(() => <OfferQuoteModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
      onClose: () => {
        checkSmsAvailability();
      },
    });
  };

  return (
    <CustomButton
      id="bid-quote-button"
      onClick={offerQuoteHandler}
      disabled={!canSendSmsCode}
      tooltip={!canSendSmsCode ? `Повторная подача котировки будет доступна через ${timeLeft} секунд` : undefined}
    >
      Предложить котировку
    </CustomButton>
  );
});
